import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { NgAbstractInputComponent } from '../../shared/inputs.abstract';
import { EnumNgEventName } from '../../../../animations/event-animations/shared/event-animation.data';


@Component({
    selector: 'ng-round-animated-checkbox',
    templateUrl: './round-animated-checkbox.component.html',
    styleUrls: ['./round-animated-checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: NgRoundAnimatedCheckboxComponent,
            multi: true
        }
    ],
    standalone: false
})
export class NgRoundAnimatedCheckboxComponent extends NgAbstractInputComponent<boolean> implements ControlValueAccessor {

	//** Configurations */
	readonly EnumNgEventName: typeof EnumNgEventName = EnumNgEventName;

	constructor() {
		super('round-animated-checkbox');
	}

	//** Setup on change */
	onSelected(): void {
		this.onChange(this.value!);
	}
}
